import React, { useCallback, useEffect, useMemo } from "react";
import { TreeItem } from "@components_v2/tree-view";
import { ImageDriveOn, ImageFolderSmallOn } from "@mzc-cloudplex/icons";
import FolderTreeViewSkeleton from "./folder-tree-view-skeleton";
import theme from "@styles/theme";
const CategoryTreeViewItem = ({
    resourceType,
    data,
    renderTreeNodeIcon,
    onToggleGroupFold,
    onClickTreeItem,
    renderTree,
    foldDisabled,
    pending,
}) => {
    const nodeId = useMemo(() => (data?.id ? String(data.id) : ""), [data?.id]);

    const getTreeDepth = useMemo(() => {
        if (!data) return 0;
        if (data.isRoot || data.isGroup) return 0;
        return data.code.split("_").length - 1;
    }, [data]);

    if (!data?.id) return null;

    return (
        <TreeItem
            type={"Category"}
            depth={getTreeDepth}
            icon={renderTreeNodeIcon}
            nodeId={nodeId}
            label={data.name === "Uncategorized Assets" ? `Uncategorized ${resourceType}` : data.name}
            foldDisabled={foldDisabled}
            onClick={(e) => {
                e.stopPropagation();
                onClickTreeItem(data);
            }}
            onClickExpand={() => {
                // 설명: 열기/닫기 아이콘 전용
                data.hasOwnProperty("isFold") && onToggleGroupFold(data);
            }}
            sx={{
                borderTop: data.name === "Uncategorized Assets" ? `1px solid ${theme.palette.secondary[100]}` : `0`,
                borderBottom: data.name === "Uncategorized Assets" ? `1px solid  ${theme.palette.secondary[100]}` : `0`,
                marginTop: data.name === "Uncategorized Assets" ? 1.5 : 0,
                padding: data.name === "Uncategorized Assets" ? `12px 0` : 0,
                ".MuiTypography-root": { fontSize: "14px", fontWeight: "normal" },
            }}
        >
            {data.children?.length > 0 && renderTree(data?.children)}
            {pending && <FolderTreeViewSkeleton type={"child"} depth={getTreeDepth + 1} />}
        </TreeItem>
    );
};

export default CategoryTreeViewItem;
